import { useMemo } from 'react';

import { useCustomerGetCustomerProfile } from '@eneco/dc/hooks';
import useDC from '@eneco/dc/useDC';
import { Customers_Profile_CustomerProfileResponse } from '@monorepo-types/dc';

type Props =
  | {
      filterInactive?: boolean;
      shouldFetch?: boolean;
    }
  | undefined;

export const useCustomerProfileAccount = ({ filterInactive, shouldFetch = true }: Props = {}) => {
  const response = useCustomerGetCustomerProfile(shouldFetch === false ? null : undefined);

  const accounts = filterInactive
    ? response.data?.accounts?.filter(account => account.customerProfileType !== 'nonActive')
    : response?.data?.accounts;
  const { accountId } = useDC();
  const hasMultipleAccounts = (accounts?.length || 0) > 1;
  const currentAccount = accounts?.find(account => account.accountId === accountId);

  return useMemo(
    () => ({
      currentAccount,
      hasMultipleAccounts,
      ...response,
      data: { ...response?.data, accounts } as Customers_Profile_CustomerProfileResponse,
    }),
    [accounts, currentAccount, hasMultipleAccounts, response],
  );
};
